import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { Utilities } from '@core/helpers/utilities';
import { my_AllElemConsiglioAmministrazioneHelper, my_CalcObbOrganoContrHelper } from '../../warnings/amm-controllo-common-warnings';
import { toNum } from '@shared/helpers/math.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { RULE_2018_WARNING } from '@shared/constants/shared.constants';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';

@Injectable()
export class NormeSrlWarningsService {
    constructor(private store: Store<Revisione53State>) {}

    my_CkSrlAssembNominSind = createWarning(this.store, (myVerbale) => {
        const my_AmministrazioneControllo = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
        const my_CkSrlAssembNominSind = my_AmministrazioneControllo.my_NormeSrl.my_CkSrlAssembNominSind;
        const my_CalcoloSRL20 = my_AmministrazioneControllo.my_NormeSrl.my_CalcoloSRL20;

        if (my_CkSrlAssembNominSind === '0' && my_CalcoloSRL20 === 'true') {
            return "La cooperativa deve avere l'organo di controllo";
        } else {
            return null;
        }
    });

    my_CkSrlCoopSoci = createWarning(this.store, (myVerbale) => {
        const my_AmministrazioneControllo = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
        const my_CkNorme = toNum(my_AmministrazioneControllo.my_CkNorme);
        const my_CkSrlCoop20Soci = toNum(my_AmministrazioneControllo.my_NormeSrl.my_CkSrlCoop20soci);
        const my_CkSrlCoop9Soci = toNum(my_AmministrazioneControllo.my_NormeSrl.my_CkSrlCoop9soci);

        if (!(my_CkNorme !== 1 || my_CkSrlCoop9Soci !== 0 || my_CkSrlCoop20Soci !== 0)) {
            return 'Attenzione: la cooperativa ha superato i parametri per adozione delle norme SRL';
        } else {
            return null;
        }
    });

    my_CkSrlTipoAmministrazione = createWarning(this.store, (myVerbale) => {
        const my_AmministrazioneControllo = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
        const my_CkSrlTipoAmministrazione = toNum(my_AmministrazioneControllo.my_NormeSrl.my_CkSrlTipoAmministrazione);
        const my_CkNorme = toNum(my_AmministrazioneControllo.my_CkNorme);
        const my_DataRevisioneDal = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal;

        if (!(my_CkNorme !== 1 || my_CkSrlTipoAmministrazione !== 2 || Utilities.isDateAfter('01-01-2018', my_DataRevisioneDal))) {
            return "Attenzione : per le modifiche introdotte dalla legge di bilanci 2018, l'amministrazione della cooperativa non può essere affidata ad un amministratore unico";
        } else {
            return null;
        }
    });

    my_CalcObbOrganoContr = createWarning(this.store, (myVerbale) => {
        return my_CalcObbOrganoContrHelper(myVerbale, CkNormeValuesEnum.normeSrl);
    });

    my_DataRevisioneDal = createWarning(this.store, (myVerbale) => {
        if (this._checkLegge2018(myVerbale)) {
            return RULE_2018_WARNING;
        } else {
            return null;
        }
    });

    my_SrlScadenzaAmministratoriWarnings = createWarning(this.store, (myVerbale) => {
        const warnings: string[] = [];
        const my_AmministrazioneControllo = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
        const my_CkSrlTipoAmministrazione = toNum(my_AmministrazioneControllo.my_NormeSrl.my_CkSrlTipoAmministrazione);
        const my_CkScadenzaOrgAmm = toNum(my_AmministrazioneControllo.my_CkScadenzaOrgAmm);

        if (this._checkLegge2018(myVerbale)) {
            warnings.push(RULE_2018_WARNING);
        }

        if (!(my_CkScadenzaOrgAmm === -1 || my_CkSrlTipoAmministrazione !== 1)) {
            warnings.push('Verificare la scadenza del CDA');
        }

        return warnings?.length ? warnings : null;
    });

    my_AllElemConsiglioAmministrazione = createWarning(this.store, (myVerbale) => {
        return my_AllElemConsiglioAmministrazioneHelper(myVerbale, CkNormeValuesEnum.normeSrl);
    });

    private _checkLegge2018(myVerbale: MyVerbale): boolean {
        const my_AmministrazioneControllo = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
        const my_CkNorme = toNum(my_AmministrazioneControllo.my_CkNorme);
        const my_DataRevisioneDal = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal;
        const my_SrlScadenzaAmministratori = toNum(my_AmministrazioneControllo.my_NormeSrl.my_SrlScadenzaAmministratori);
        const my_CkSrlTipoAmministrazione = toNum(my_AmministrazioneControllo.my_NormeSrl.my_CkSrlTipoAmministrazione);
        return !(my_CkNorme !== 1 || my_SrlScadenzaAmministratori !== 99 || my_CkSrlTipoAmministrazione === 3 || Utilities.isDateAfter('01-01-2018', my_DataRevisioneDal));
    }
}
